define('views/components/reseller_personal/reseller_personal_list',['require','views/base/list_view','views/components/reseller_personal/reseller_personal','text!templates/components/reseller_personal/reseller_personal_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/reseller_personal/reseller_personal');

    var temp = require("text!templates/components/reseller_personal/reseller_personal_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

